<template>
  <div>
    <NavBar v-bind:displayLogo="true" v-bind:displayUser="false"></NavBar>
    <div class="container-login justify-content-center">
      <div class="card-login">
        <div class="card-header-login">
          <h5>{{titlereg}}</h5>
          <button class="btn btn-primary" @click="homeRedirect">{{home}}</button>
        </div>
        <div class="card-body">
          <p>{{subtitlereg}}</p>
          <div  v-show="mostrar" id="postulantes"></div>
<!--          <formio :src="artboResetPassword" v-on:change="onFormRender()"  v-on:submit="onSubmitMethod"></formio>-->
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
  import NavBar from '@component-basic/NavBar.vue'
  import { Form } from "vue-formio";
  import { config } from '@/formio/config'
  import { navBar } from '@utils/translations';
  import {Formio} from 'formiojs';

export default {
  components: {
    formio: Form,
    NavBar
  },
  data() {

    return {
      // artboResetPassword: config.forms.reset,
      artboResetPassword: config.forms.resetpassword,
      home:"",
      titlereg:"",
      subtitlereg:"",
      validation: true,
      mostrar: false,
    };
  },
  mounted() {
    Formio.logout()
    localStorage.removeItem("formioToken")
    localStorage.removeItem("formioUser")
    let lang = localStorage.getItem('lang');
    this.home =  navBar[lang].home;
    this.titlereg =  navBar[lang].titlereg;
    this.subtitlereg =  navBar[lang].subtitlereg;

  },
  created: async function()
  {

    var form = new Formio(config.forms.resetpassword);
    let context = this;
    let panfinal = [];
    let componente = await form.loadForm().then(async function (formio) {

      var count = 0;
      let flag = "false";
      context.flag = flag;
      context.pageList = panfinal;
      return [ formio.components, panfinal];

    });
    Formio.createForm(document.getElementById('postulantes'),{
      components: componente[0],
      display: "form",

    }).then(function(wizard)
    {
      context.clearLocalStorage()
      //wizard.options.highlightErrors = false;
      //wizard.options.disableAlerts = true;
      //wizard.options.noAlerts = true;
      /////////////////////////////////////////////
      var rand=()=>Math.random(0).toString(36).substr(2);
      var tokenD=(length)=>(rand()+rand()+rand()+rand()).substr(0,length);
      wizard.data.token = tokenD(40);
      context.formulario = wizard;
      wizard.on('submit', function(submission) {
        context.clearLocalStorage()
        console.log(submission)
        form.saveSubmission(submission);
      });
      wizard.on('error', function(error) {
        console.log(error)
      });
      return wizard;

    }).then(function (test) {
      context.mostrar = true;
    });
  },
  methods: {
    clearLocalStorage(){
      localStorage.removeItem("formioToken")
      localStorage.removeItem("formioUser")
    },
    onFormRender()
    {
      setTimeout(() => {
        if(this.validation)
        {
          $('input[name ="data[token]"]').val(this.tok)
          this.validation = false;
        }
      }, 1000)

    },
    homeRedirect: function() {
      this.$router.push({ name: "home" });
    },
    onSubmitMethod: function(submission) {
      alert(submission);
      console.log(submission);
    }
  }
};
</script>

<style>
.formio-component-token{
  display:none;
}
.fa.fa-refresh.fa-spin.button-icon-right{
  display: none;
}
</style>
